import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Gibt einen Friedhof zurück.
 */
export function getCementery(id: number): JQueryPromise<modelsGet.ICementery>
{
    var endpoint = new URI("api/cementeries");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ICementery>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Friedhöfe zurück.
 */
export function getCementeries(): JQueryPromise<modelsGet.ICementery[]>
{
    var endpoint = new URI("api/cementeries");

    return api.get<modelsGet.ICementery[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(jsonData: modelsPost.ICementery): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/cementeries/create",
        data: JSON.stringify(jsonData)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, jsonData: modelsPost.ICementery): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/cementeries/edit/${id}`,
        data: JSON.stringify(jsonData)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/cementeries/delete/${id}`
    });
}